import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole 
}) => {
  const { accounts, inProgress } = useMsal();

  if (inProgress === 'login') {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (accounts.length === 0) {
    return <Navigate to="/login" replace />;
  }

  // TODO: Implement role-based access control
  if (requiredRole) {
    const account = accounts[0];
    const roles = (account.idTokenClaims as any)?.roles || [];
    
    if (!roles.includes(requiredRole)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <>{children}</>;
};
